
import {Component, Vue, Watch} from 'vue-property-decorator'
import {completeUserLoginInfo, getFigureCode, sendCode, sendEmailCode, loginByMobile} from "@/apis/login/login";
import { getCollegeList } from '@/apis/myInfo/myInfo'
import { getSchoolList } from "@/apis/login/login"
import {getMobilexdomain} from '@/utils/utils';
import { Toast } from 'vant';
import { SERVICE_TERMS_VERSION } from '@/constants/serviceTerms';

@Component({
})
export default class Register extends Vue {
    private picCodeUrl = '';
    private sessionId = '';
    private mobilePhoneOrEmail = ''
    private shareClassFromCode:any=''
    private password = '';
    private passwordConfirm = ''
    private identType: 'teacher'| 'student' | null = null;
    private registerStep: 'role' | 'form' = 'role'
    private agreedServiceTerms = false
    private userName = '';
    private code = '';
    private smsCode = '';
    private smsCountDown = 0;
    private isShowSmsPicPopUp = false;
    private smsPicCodeInput = '';
    private smsPicCodeError = '';
    private submitting = false
    private smsSending = false
    private registerType: 'fast' | 'normal' = 'normal'
    private registMod: 'mobile'| 'email' = 'mobile'
    private stno :string = '';
    private teacherImg = require('@/assets/images/teacher.svg')
    private studentImg = require('@/assets/images/student.svg')
    private showSearchSchool = false
    private searchText = ''
    private schoolList: any = []
    private isSchool: number = -1
    private index: number = -1
    private schoolName = ''
    private reqMap = new Map()
    @Watch('showSearchSchool')
    onShowSearchSchool(newVal: boolean) {
      if (!this.reqMap.has('hasLoadList') && newVal) {
        this.getSchoolList()
        this.reqMap.set('hasLoadList', true)
      }
    }
    get selectedSchoolName() {
      const name = this.richtextFilter(this.schoolName)
      return name
    }
    goSearchSchool() {
      this.$router.push('/schoolSearch')
    }
    onRoleNext() {
      if (!this.identType) {
        Toast(this.$t('Account.请先选择身份') as string)
        return
      }
      this.registerStep = 'form'
    }
    setRegisterType(type: 'normal' | 'fast') {
      if (this.registerType === type) return
      this.registerType = type
      if (type === 'fast' && !/^1\d{10}$/.test(this.mobilePhoneOrEmail)) {
        this.mobilePhoneOrEmail = ''
        this.smsCode = ''
        this.smsCountDown = 0
      }
    }
    openClauseService() {
      this.$router.push('/clauseService')
    }
    validateRegisterForm(): string {
      if (this.registerType === 'fast') {
        if (!/^1\d{10}$/.test(this.mobilePhoneOrEmail)) {
          return this.$t('ktpMy.请输入正确的手机号') as string
        }
        if (!this.smsCode) {
          return this.$t('Account.请输入短信验证码') as string
        }
      } else if (!this.checkMobilePhoneOrEmail()) {
        return this.$t('Account.请输入正确格式的账号') as string
      } else if (!this.password) {
        return this.$t('Account.请输入密码') as string
      } else if (!this.checkPassword(this.password)) {
        return this.$t('Account.密码强度过低') as string
      } else if (!this.checkPasswordConfirm(this.passwordConfirm)) {
        return this.$t('Account.两次密码应该相同') as string
      }
      if (!this.userName.trim()) {
        return this.$t('Account.请输入用户名') as string
      }
      if (!this.selectedSchoolName.trim()) {
        return this.$t('Account.请输入或者选择学校') as string
      }
      if (!this.stno.trim()) {
        return this.identType === 'teacher'
          ? this.$t('ktpMy.请输入教工号') as string
          : this.$t('ktpMy.请输入学号') as string
      }
      if (!this.code) {
        return this.$t('Account.请输入验证码') as string
      }
      return ''
    }
    checkMobilePhoneOrEmail() {
      if (this.registerType === "fast") return true;
      let isMobilePhone = /^1\d{10}$/.test(this.mobilePhoneOrEmail);
      let isEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.mobilePhoneOrEmail);
      if (isMobilePhone) {
        this.registMod = 'mobile'
      }
      if (isEmail) {
        this.registMod = 'email'
      }
      return ( isEmail || isMobilePhone)
    }

    checkPassword(values:any) {
      if(values == ""){
        return true;
      }
      if (this.registerType === "fast"){
        return true;
      }
      const regular = {
          password1: /^.{6,20}$/,
          password2: /^(?=.*[A-Za-z0-9].*)(?=.*[\W0-9_].*)(?=.*[A-Za-z\W_].*).{6,20}$/,
          password3: /^(?=.*[A-Za-z].*)(?=.*[\W_].*)(?=.*[0-9].*).{6,20}$/
      }
      if (regular.password3.test(values)) {
        return true;
      } else if (regular.password2.test(values)) {
        return true;
      } else if (regular.password1.test(values)) {
        return false;
      } else {
        return false;
      }
    }

    checkPasswordConfirm(value:any) {
      if (this.passwordConfirm === '') {
        return true
      }
      return this.password === this.passwordConfirm
    }

    openSmsPicCode() {
      if (!/^1\d{10}$/.test(this.mobilePhoneOrEmail)) {
        Toast(this.$t('ktpMy.请输入正确的手机号') as string)
        return
      }
      this.smsPicCodeInput = ''
      this.smsPicCodeError = ''
      this.isShowSmsPicPopUp = true
      this.getPicCode()
    }
    closeSmsPicPopUp() {
      this.isShowSmsPicPopUp = false
    }
    onSmsPicPopUpClosed() {
      this.smsPicCodeInput = ''
      this.smsPicCodeError = ''
    }
    confirmSendSmsCode() {
      if (this.smsSending) return
      if (!this.smsPicCodeInput) {
        this.smsPicCodeError = this.$t('ktpMy.请输入正确的验证码') as string
        return
      }
      const mobilexdomain = getMobilexdomain()
      this.smsSending = true
      sendCode(this.smsPicCodeInput, this.mobilePhoneOrEmail, this.sessionId, mobilexdomain, 'reg').then(() => {
        this.isShowSmsPicPopUp = false
        this.smsPicCodeError = ''
        this.startSmsCountDown()
      }).catch((e: any) => {
        this.getPicCode()
        this.smsPicCodeError = e.message || (this.$t('ktpMy.请输入正确的验证码') as string)
      }).finally(() => {
        this.smsSending = false
      })
    }
    startSmsCountDown() {
      this.smsCountDown = 60
      const timer = setInterval(() => {
        this.smsCountDown -= 1
        if (this.smsCountDown <= 0) {
          this.smsCountDown = 0
          clearInterval(timer)
        }
      }, 1000)
    }
    sendCode() {
      if (this.submitting) return
      if (!this.agreedServiceTerms) {
        Toast(this.$t('Account.请先同意用户服务协议') as string)
        return
      }
      if (!this.identType) {
        Toast(this.$t('Account.请先选择身份') as string)
        this.registerStep = 'role'
        return
      }
      const validateMessage = this.validateRegisterForm()
      if (validateMessage) {
        Toast(validateMessage)
        return
      }
      let currentLocation:string = window.localStorage.getItem('currentLocation') || '';
      let mobilexdomain = getMobilexdomain();
      const agreementPayload = {
        agree_service_terms: 1,
        agreement_version: SERVICE_TERMS_VERSION,
        source: 'mobile',
      }
      this.submitting = true
      if (this.registerType === "normal") {
          if (this.registMod === 'mobile') {
            sendCode(this.code, this.mobilePhoneOrEmail, this.sessionId, mobilexdomain, 'reg').then(res => {
              const registerUserInfo = {
                type: this.identType,
                email: this.mobilePhoneOrEmail,
                password: this.password,
                username: this.userName,
                school: this.selectedSchoolName,
                stno: this.stno,
                ...agreementPayload,
              }
              window.sessionStorage.setItem('registerUserInfoCache', JSON.stringify(registerUserInfo));
              this.$router.push({ path: '/loginVerify' });
            }).catch(e => {
              this.getPicCode();
            }).finally(() => {
              this.submitting = false
            })
          } else if (this.registMod === 'email') {
            sendEmailCode(this.code, this.mobilePhoneOrEmail, this.sessionId).then(res => {
              const registerUserInfo = {
                type: this.identType,
                email: this.mobilePhoneOrEmail,
                password: this.password,
                username: this.userName,
                school: this.selectedSchoolName,
                stno: this.stno,
                ...agreementPayload,
              }
              window.sessionStorage.setItem('registerUserInfoCache', JSON.stringify(registerUserInfo));
              this.$router.push({ path: '/loginVerify' });
            }).catch(e => {
              this.getPicCode();
            }).finally(() => {
              this.submitting = false
            })
          } else {
            this.submitting = false
          }
      } else if (this.registerType === "fast") {
        loginByMobile(this.mobilePhoneOrEmail, this.smsCode).then((res) => {
          if (res.is_new !== 1) {
            Toast(this.$t('Account.手机号已注册请登录') as string)
            return Promise.reject()
          }
          window.localStorage.setItem('token_for_login', res.token)
          return completeUserLoginInfo(
            this.userName,
            this.selectedSchoolName,
            this.identType === 'teacher' ? '1' : '0',
            res.token,
            this.code,
            this.sessionId,
            this.stno,
            1,
            SERVICE_TERMS_VERSION,
          ).then(() => {
            window.localStorage.removeItem('token_for_login')
            window.localStorage.setItem('token', res.token);
            return this.$store.dispatch('setUserInfo').then(() => {
              if(currentLocation.indexOf("ShareClass")>=0){
                window.localStorage.removeItem('currentLocation');
                this.$router.push({ path: '/joinCourses' ,query: {
                  code:this.shareClassFromCode
                }});
                return
              }
              if(currentLocation.indexOf("courseHome?courseId=")>=0 || currentLocation.indexOf("joinCourse?code=")>=0){
                window.localStorage.removeItem('currentLocation');
                window.location.href = currentLocation;
                return
              }
              this.$router.push('/')
              window.dispatchEvent(new CustomEvent('onLoginSucceed'))
            });
          })
        }).catch(() => {
          window.localStorage.removeItem('token_for_login')
          this.getPicCode();
        }).finally(() => {
          this.submitting = false
        })
      } else {
        this.submitting = false
      }
    }
    getPicCode() {
      getFigureCode().then(res => {
        this.sessionId = res.sessionid
        this.picCodeUrl = res.url
      })
    }
    applyRegisterQuery() {
      const mobile = (this.$route.query.mobile || this.$route.query.userCount) as string
      if (this.$route.query.mode === 'fast' || mobile) {
        this.registerType = 'fast'
        if (mobile && /^1\d{10}$/.test(mobile)) {
          this.mobilePhoneOrEmail = mobile
        }
      }
      if (this.$route.query.shareClass) {
        this.shareClassFromCode = this.$route.query.shareClass
      }
    }
    activated() {
      this.applyRegisterQuery()
      this.getPicCode();
    }
    created() {
      this.$router.onReady(() => {
        this.applyRegisterQuery()
        if (!this.$route.query.mode && !this.$route.query.mobile && !this.$route.query.userCount) {
          this.registerType = 'normal'
        }
      })
    }
    onCancelSearch() {
      this.searchText = ''
      this.getSchoolList()
    }
    inputText() {
      this.getSchoolList()
    }
    confimSchool() {
      this.showSearchSchool = false
      if (this.schoolList.length === 0) {
        this.schoolName = this.searchText
      }
    }
    getSchoolList() {
      getSchoolList(this.searchText).then(res => {
        this.schoolList = res
      })
    }
    chooseSchoole(schoolName: string) {
      this.schoolName = schoolName
    }
    richtextFilter(str: string): string {
      if (!str) {
        return ''
      }
      let text = str
      text = text.replace(/(\n)/g, '')
      text = text.replace(/(\t)/g, '')
      text = text.replace(/(\r)/g, '')
      text = text.replace(/<\/?[^>]*>/g, '')
      text = text.replace(/\s*/g, '')
      return text
    }
  }
